import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { useHistory } from "react-router-dom";
import { Marker, Popup } from "react-leaflet";
import L, { gridLayer } from "leaflet";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import useCheckMobileScreen from "../readingView/useCheckMobileScreen";

const DynamicMarker = (props) => {
  const onlinetimeoutinmilisec = 360000; //6 mins 360 sec 360000 msec
  let onlinecheckinterval;
  const green = new L.Icon({ iconUrl: require("./../../../images/gm.svg") });
  const red = new L.Icon({ iconUrl: require("./../../../images/rm.svg") });
  const yellow = new L.Icon({ iconUrl: require("./../../../images/ym.svg") });
  const white = new L.Icon({ iconUrl: require("./../../../images/wm.svg") });
  const redandyellow = new L.Icon({
    iconUrl: require("./../../../images/rym.svg"),
  });
  const [state, setState] = useStateIfMounted({
    siteId: props.siteId,
    siteInformation: props.siteInformation,
    siteDescription: props.siteDescription,
    lastseen: props.lastseen,
    status: props.status,
    deleted: false,
    latitude: props.latitude,
    longitude: props.longitude,
    mail: props.mail,
    index: props.index,
    icon: white,
  });
  let client = mqtt_topics.mqttclientinstance;
  let when_lasttime_recieved_status = now();
  let history = useHistory();
  const target_topic =
    mqtt_topics.fixed_topic_part + props.mac + "/" + mqtt_topics.status_topic;

  function now() {
    return Math.floor(Date.now() / 1000);
  }
  function listendevicestatus() {
    client.subscribe(target_topic);
    client.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_topic) {
      try {
        when_lasttime_recieved_status = now();
        // console.log( "when_lasttime_recieved_status " + when_lasttime_recieved_status);
        // message is Buffer
        message = JSON.parse(message.toString());
        setState({
          ...state,
          status: message,
          lastseen:
            message.Fault != undefined && message.Warnings != undefined
              ? "Fault: " +
                message.Fault.toString() +
                "\n Warning: " +
                message.Warnings.toString()
              : message.Fault != undefined
                ? "Fault: " + message.Fault.toString()
                : message.Warnings != undefined
                  ? "Warning: " + message.Warnings.toString()
                  : "Online",
          icon:
            message.Fault != undefined && message.Warnings != undefined
              ? redandyellow
              : message.Fault != undefined
                ? red
                : message.Warnings != undefined
                  ? yellow
                  : green,
        });

        localStorage.setItem(
          props.mac + "_marker_state",
          JSON.stringify({
            ...state,
            status: message,
            lastseen:
              message.Fault != undefined && message.Warnings != undefined
                ? "Fault: " +
                  message.Fault.toString() +
                  "\n Warning: " +
                  message.Warnings.toString()
                : message.Fault != undefined
                  ? "Fault: " + message.Fault.toString()
                  : message.Warnings != undefined
                    ? "Warning: " + message.Warnings.toString()
                    : "Online",
            icon:
              message.Fault != undefined && message.Warnings != undefined
                ? "redandyellow"
                : message.Fault != undefined
                  ? "red"
                  : message.Warnings != undefined
                    ? "yellow"
                    : "green",
          }),
        );
        localStorage.setItem(props.mac + "_marker_time", now());
      } catch (error) {}
    }
  }

  function checkifstillonline() {
    let been = now() - when_lasttime_recieved_status;
    //console.log("been " + been + "now()" + now());
    if (been >= onlinetimeoutinmilisec / 1000) {
      //offline
      setState({
        ...state,
        status: {},
        icon: white,
        lastseen: "Offline",
      });
    }
  }

  function connecttolivedisplay() {
    if (
      props.entered_pass == undefined ||
      props.entered_pass == props.userpass ||
      props.entered_pass == props.clientpass ||
      props.entered_pass == props.seniorpass ||
      props.entered_pass == props.saspass
    ) {
      mqtt_topics.choosenmac = props.mac;
      mqtt_topics.choosenid = props.siteId;
      mqtt_topics.choosendevicefirmwaretype = props.subtype;
      mqtt_topics.latitude = props.latitude;
      mqtt_topics.longitude = props.longitude;
      //props.parentPropsHistory.push("/ld");
      localStorage.setItem("userpass_of_" + props.mac, props.userpass);
      localStorage.setItem("clientpass_of_" + props.mac, props.clientpass);
      localStorage.setItem("seniorpass_of_" + props.mac, props.seniorpass);
      localStorage.setItem("saspass_of_" + props.mac, props.saspass);
      localStorage.setItem("designtype_of_" + props.mac, props.designtype);
      localStorage.setItem("type_of_" + props.mac, props.type);
      localStorage.setItem("timezone_of_" + props.mac, props.timezone);
      localStorage.setItem("sv_of_" + props.mac, props.softwareversion);
      localStorage.setItem("fu_of_" + props.mac, props.fu);
      localStorage.setItem("lr_of_" + props.mac, props.lr);
      localStorage.setItem("fl_of_" + props.mac, props.fl);
      localStorage.setItem("fr_of_" + props.mac, props.fr);
      localStorage.setItem(
        "entered_pass_of_" + props.mac,
        props.entered_pass == undefined ? "000" : props.entered_pass,
      );
      history.push({
        pathname: "/ld",
      });
    } else {
      alert.show(
        "The device password has been changed. Please re-add the device using the new password.",
        {
          type: "error",
          position: "middle",
        },
      );
    }
  }
  useEffect(() => {
    //get the last state if available
    let savedstate = localStorage.getItem(props.mac + "_marker_state");
    if (savedstate != undefined && savedstate != "") {
      savedstate = JSON.parse(savedstate);
      if (savedstate.status != undefined) {
        //check if data valid
        if (
          now() - Number(localStorage.getItem(props.mac + "_marker_time")) <
          6 * 60
        ) {
          //check data late 6 mins timeout
          setState({
            ...state,
            siteId: props.siteId,
            siteInformation: props.siteInformation,
            siteDescription: props.siteDescription,
            lastseen: savedstate.lastseen,
            status: savedstate.status,
            deleted: false,
            latitude: props.latitude,
            longitude: props.longitude,
            mail: props.mail,
            index: props.index,
            icon: eval(savedstate.icon),
          });
        }
      }
    }

    listendevicestatus();
    checkifstillonline();
    onlinecheckinterval = setInterval(function () {
      checkifstillonline();
    }, onlinetimeoutinmilisec);
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      client.unsubscribe(target_topic);
      clearInterval(onlinecheckinterval);
      client.removeListener("message", handleMqttMessage);
    },
    [],
  );
  if (
    state.latitude != "" &&
    state.latitude != undefined &&
    state.longitude != "" &&
    state.longitude != undefined
  ) {
    return (
      <Marker position={[state.latitude, state.longitude]} icon={state.icon}>
        <Popup>
          <center>
            <strong title="Site id">{state.siteId}</strong> <br />
            <span title="Site information">{state.siteInformation}</span> <br />
            <span title="Site description">{state.siteDescription} </span>
            <br />
            <br />
            <button
              className="btn btn-primary btn-sm"
              onClick={() => connecttolivedisplay()}
            >
              Connect
            </button>
            <br />
            <hr /> {state.lastseen}
          </center>
        </Popup>
      </Marker>
    );
  } else {
    return null;
  }
};
export default DynamicMarker;
